import React, { useEffect } from "react";
import AOS from "aos";
import products from "../../api/products";
import SectionTitle from "../SectionTitle/SectionTitle";
import ProductCard from "./ProductCard";

const ProductSection = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  return (
    <section className="blog-section section-padding" data-aos="fade-down">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              subtitle="Kelola Media Sosial"
              title="Paket Jasa Kelola Media Sosial"
            />
          </div>
        </div>
        <div className="row align-items-stretch">
          {products.map((product, pkye) => (
            <div className="col col-lg-4 col-md-6 col-12" key={pkye}>
              <ProductCard
                title={product.name}
                price={product.normalPrice}
                promo={product.promoPrice}
                included={product.includeFeatures}
                excluded={product.excludeFeatures}
                contact={props.contact}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
